export const CURRENT_VIEW = 'CURRENT_VIEW',
  CURRENT_LIST_VIEW = 'CURRENT_LIST_VIEW',
  UPDATE_FOLDERS = 'UPDATE_FOLDERS',
  SELECT_FOLDER = 'SELECT_FOLDER',
  ADD_LIST = 'ADD_LIST',
  REMOVE_LIST = 'REMOVE_LIST',
  RESET_LIST = 'RESET_LIST',
  TOGGLE_CANOPY_MODAL = 'TOGGLE_CANOPY_MODAL',
  UPDATE_FILTERS = 'UPDATE_FILTERS',
  CLEAR_FILTERS = 'CLEAR_FILTERS',
  SET_FILTER_COUNT = 'SET_FILTER_COUNT',
  SET_LANGUAGE = 'SET_LANGUAGE',
  UPDATE_LIST_DATA = 'UPDATE_LIST_DATA',
  UPDATE_SPATIAL_DATA = 'UPDATE_SPATIAL_DATA',
  UPDATE_FILTERED_DATA = 'UPDATE_FILTERED_DATA',
  UPDATE_LIST_LEVEL_ANALYSIS = 'UPDATE_LIST_LEVEL_ANALYSIS',
  UPDATE_SELECTED_LOCATIONS = 'UPDATE_SELECTED_LOCATIONS',
  UPDATE_SELECTED_AND_VISIBLE_LOCATIONS = 'UPDATE_SELECTED_AND_VISIBLE_LOCATIONS',
  UPDATE_INFO_BUBBLE_CACHE = 'UPDATE_INFO_BUBBLE_CACHE',
  TOGGLE_POPOVER = 'TOGGLE_POPOVER',
  UPDATE_LOADING_ICON_ID = 'UPDATE_LOADING_ICON_ID',
  UPDATE_DIAGNOSTIC_VIEW = 'UPDATE_DIAGNOSTIC_VIEW',
  UPDATE_SELECTED_LIST = 'UPDATE_SELECTED_LIST',
  DEFORESTATION_DISPLAY_FORMAT = 'DEFORESTATION_DISPLAY_FORMAT',
  NATURAL_FOREST_LOSS_DATA_SOURCE = 'NATURAL_FOREST_LOSS_DATA_SOURCE',
  SHOW_INFO_POPOVER = 'SHOW_INFO_POPOVER';
